'use client'

import { useState } from 'react'
import Spinner from '@/shared/components/Spinner'
import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { clearRootApiClientAccessToken } from '@/lib/apis/clients/ApiClientStore'

type Props = {
  onLogout: () => Promise<void>
}

export function DesktopLogoutButton({ onLogout }: Props) {
  const [loading, setLoading] = useState(false)

  return (
    <button
      className={clsx(
        'flex h-[42px] items-center justify-center rounded-full bg-[#fbeaea] px-5 text-[15px] font-semibold leading-[18px] text-[#c24040] transition-colors',
        loading
          ? 'cursor-not-allowed'
          : 'hover:bg-[#f5dede] hover:text-[#a93232]',
      )}
      type="button"
      disabled={loading}
      onClick={async () => {
        setLoading(true)
        clearRootApiClientAccessToken()
        try {
          await onLogout()
        } finally {
          clearRootApiClientAccessToken()
        }
      }}
    >
      {loading && (
        <span className="mr-1.5">
          <Spinner />
        </span>
      )}{' '}
      Sign Out
    </button>
  )
}

type MobileProps = {
  title: string
  icon?: IconProp
  closeMenu: () => void
} & Props

export function MobileLogoutButton({
  title,
  icon,
  closeMenu,
  onLogout,
}: MobileProps) {
  const [loading, setLoading] = useState(false)

  return (
    <button
      onClick={async () => {
        setLoading(true)
        clearRootApiClientAccessToken()
        try {
          await onLogout()
          closeMenu()
        } finally {
          clearRootApiClientAccessToken()
        }
      }}
      className="flex min-h-[43px] w-full items-center px-1 py-3 text-left font-sans text-[15px] font-medium leading-[19px] text-[#82828b] transition-colors hover:text-[#0b0b0f] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-[#2563eb] disabled:cursor-wait disabled:opacity-60"
      disabled={loading}
    >
      {icon && (
        <FontAwesomeIcon fixedWidth={true} icon={icon} className="mr-2" />
      )}
      <span>{title}</span>
      {loading && (
        <span className="ml-1.5">
          <Spinner size={4} />
        </span>
      )}
    </button>
  )
}
